import { createApp, h } from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import * as Sentry from '@sentry/vue'
import messages from './Utils/Locales/messages'
import { createI18n } from 'vue-i18n'
import globalPlugins from './Utils/Helpers/globalPlugins'

InertiaProgress.init({ color: '#1B154B' })


const language = navigator.language
const locale = language.split('-')[0]
const i18n = createI18n({
  locale,
  fallbackLocale: 'en',
  messages: messages
});

var createAppVue = createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - Nafa Support` : 'Nafa Support',
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(i18n)
      .use(plugin)
      .use(globalPlugins)
      .mount(el)
  },
})

Sentry.init({
  app: createAppVue,
  dsn: process.env.SENTRY_VUE_DSN,
  integrations: [
    Sentry.replayIntegration(),
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

})

